import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css';
import Enrollment from './pages/Enrollment/Enrollment';
import SetPreferences from './pages/SetPreferences/SetPreferences';
import FakePartner from './pages/FakePartner/FakePartner';
import ConfirmEmail from './pages/ConfirmEmail/ConfirmEmail';
import PendingResource from './pages/PendingResource/PendingResource';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import MobileEnrollment from './pages/MobileEnrollment/MobileEnrollment';
import Enrollmentv2 from './pages/Enrollmentv2/Enrollmentv2';
import './opensans-font.css';
import './material-design-iconic-font.css'
import './material-design-iconic-font.min.css'
import './style.css';
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MobileEnrollment></MobileEnrollment>} />
        <Route path="/Enrollment" element={<MobileEnrollment></MobileEnrollment>} />
        <Route path="/Enrollmentv1" element={<Enrollment />} />
        <Route path='/Enrollmentv2' element={<GoogleOAuthProvider clientId='501893506612-vhhsltnou76fjhfi3r833etnvmcldr5n.apps.googleusercontent.com'
        ><Enrollmentv2 /></GoogleOAuthProvider>} />
        <Route path='/auth/apple/callback' element={<GoogleOAuthProvider clientId='501893506612-vhhsltnou76fjhfi3r833etnvmcldr5n.apps.googleusercontent.com'
        ><Enrollmentv2></Enrollmentv2></GoogleOAuthProvider>} />
        <Route path="/SetPreferences" element={<SetPreferences></SetPreferences>} />
        <Route path="/Enrollment" element={<Enrollment></Enrollment>} />
        <Route path="/FakePartner" element={<FakePartner></FakePartner>} />
        <Route path='/ConfirmEmail' element={<ConfirmEmail></ConfirmEmail>} />
        <Route path='/ContinueApplication' element={<PendingResource></PendingResource>} />
        <Route path='/privacy_policy' element={<PrivacyPolicy></PrivacyPolicy>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
